import { createFileRoute } from '@tanstack/react-router';

import { getContactQueryOptions } from '@/_pages/contacts/api-service';
import Loading from '@/_pages/contacts/notes/loading';

export const Route = createFileRoute('/_private/contacts/_template/$id/notes')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getContactQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Notes',
    tabKey: 'contact/notes',
    isViewOnly: true,
    renderRightColumn: false,
    isFullWidth: true,
  },
  pendingComponent: Loading,
});
